module.exports = __webpack_public_path__ + "static/media/product-marketing-first.2d047289.jpg";